import * as React from 'react';

import { PageTitleBar } from 'components';

const PageBuilderFooterHeader = () => (
  <PageTitleBar showBackButton={false} headerTitle='فوتر' />
);

export { PageBuilderFooterHeader };
